import { parseUnits } from "ethers/lib/utils";
import { getAssets } from "../constants/constants";
import { getAssetColor } from "./asset";
export var isVaultFull = function (deposits, cap, decimals) {
    var margin = parseUnits("0.01", decimals);
    return !cap.isZero() && deposits.gte(cap.sub(margin));
};
export var isETHVault = function (vault) { return vault === "rETH-THETA"; };
export var getVaultColor = function (vault) {
    return getAssetColor(getAssets(vault));
};
//# sourceMappingURL=vault.js.map